<template>
  <div class="pt-20">
    <!--Header-->
    <div class="header relative py-32 bg-black">
      <div
        class="absolute inset-0 bg-cover bg-center bg-blue-200 opacity-75"
        style="
          background-image: url(./img/brand/header-employer.jpg);
          background-blend-mode: multiply;
        "
      ></div>

      <div class="px-4 md:px-0 container relative">
        <div class="flex">
          <div class="pt-5 pb-32">
            <h1 class="text-4xl text-white font-extrabold mb-2">Partner With VIVA Finance</h1>
            <h5 class="text-lg text-white mb-5">
              Empower Your Employees Through Financial Wellness
            </h5>
            <base-button type="primary" aria-label="form" class="mb-5">
              <a class="" rel="noopener" target="_blank" href="mailto:info@vivafinanceco.com"
                ><span class="text-white">Request a Demo</span></a
              >
            </base-button>
          </div>
        </div>
      </div>
      <div class="hidden lg:block separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon style="fill: #f8f9fe" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>

    <section>
      <div class="px-4 md:px-0 container py-6">
        <div class="md:block flex flex-col items-center md:items-start justify-center">
          <h2 class="text-xl font-semibold mb-1">The Facts</h2>
          <div class="h-1 w-6 rounded viva-blue mb-5"></div>
        </div>

        <div class="flex flex-wrap -mx-3">
          <div class="w-full lg:w-1/3 px-3 pb-4 flex">
            <div class="w-full card-shadow dashboard-card flex flex-col items-center p-5">
              <animated-number
                :value="value"
                :formatValue="formatToPrice"
                :duration="1500"
                class="absolute text-3xl font-medium text-black font-mono"
                style="margin-top: 55px"
              />
              <progress-bar
                type="circle"
                ref="line"
                :options="options"
                color="#68d391"
                strokeWidth="7.0"
                duration="1500"
                trailColor="#edf2f7"
                trailWidth="7.0"
                class="w-40"
              >
              </progress-bar>
              <h2 class="my-4 h2 text-default text-center">
                of workers do not have $500 saved for unexpected expenses
              </h2>
              <p class="text-muted font-bold uppercase text-xs mt-auto">Bankrate.com</p>
            </div>
          </div>
          <div class="w-full lg:w-1/3 px-3 pb-4 flex">
            <div class="w-full card-shadow dashboard-card flex flex-col items-center p-5">
              <animated-number
                :value="value2"
                :formatValue="formatToPrice2"
                :duration="1500"
                class="absolute text-3xl font-medium text-black font-mono"
                style="margin-top: 55px"
              />
              <progress-bar
                type="circle"
                ref="line2"
                :options="options"
                color="#68d391"
                strokeWidth="7.0"
                duration="1500"
                trailColor="#edf2f7"
                trailWidth="7.0"
                class="w-40"
              >
              </progress-bar>
              <h2 class="my-4 h2 text-default text-center">of workers live paycheck to paycheck</h2>
              <p class="text-muted font-bold uppercase text-xs mt-auto">Career Builder</p>
            </div>
          </div>
          <div class="w-full lg:w-1/3 px-3 pb-4 flex">
            <div class="w-full card-shadow dashboard-card flex flex-col items-center p-5">
              <animated-number
                :value="value3"
                :formatValue="formatToPrice3"
                :duration="1500"
                class="absolute text-3xl font-medium text-black font-mono"
                style="margin-top: 55px"
              />
              <progress-bar
                type="circle"
                ref="line3"
                :options="options"
                color="#68d391"
                strokeWidth="7.0"
                duration="1500"
                trailColor="#edf2f7"
                trailWidth="7.0"
                class="w-40"
              >
              </progress-bar>
              <h2 class="my-4 h2 text-default text-center">
                of workers report stress dealing with financial issues
              </h2>
              <p class="text-muted font-bold uppercase text-xs mt-auto">PwC</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="viva-blue">
      <div class="container py-24 flex flex-col items-center justify-center">
        <div class="md:block flex flex-col w-full items-center justify-center">
          <h2 class="text-xl font-semibold mb-3 text-white">Our Services</h2>
          <div class="h-1 w-6 rounded bg-white mb-5"></div>
        </div>

        <div class="flex flex-col lg:flex-row">
          <div class="flex flex-col lg:flex-row">
            <div class="lg:w-1/3 flex flex-col items-center my-4 lg:my-0">
              <i class="far fa-credit-card text-blue-100 text-xl mb-4"></i>
              <div class="flex items-start justify-center">
                <h1 class="text-white text-center text-lg font-semibold">
                  Affordable, Salary-Linked Loans
                </h1>
              </div>
              <div>
                <p class="text-blue-100 py-1 px-4 text-center text-sm leading-tight">
                  To help employees manage unexpected expenses and existing, expensive debt.
                </p>
              </div>
            </div>

            <div class="bg-gray-200 mx-2 h-full w-px rounded-full"></div>
            <div class="lg:w-1/3 flex flex-col items-center my-4 lg:my-0">
              <i class="fas fa-graduation-cap text-blue-100 text-xl mb-4"></i>
              <div class="flex items-start justify-center">
                <h1 class="text-blue-100 text-center text-lg font-semibold">
                  Financial Coaching and Education
                </h1>
              </div>
              <div>
                <p class="text-white py-1 px-4 text-center text-sm leading-tight">
                  To help employees understand their personal finances.
                </p>
              </div>
            </div>

            <div class="bg-gray-200 mx-2 h-full w-px rounded-full"></div>
            <div class="lg:w-1/3 flex flex-col items-center my-4 lg:my-0">
              <i class="fas fa-chart-line text-blue-100 text-xl mb-4"></i>
              <div class="flex items-start justify-center">
                <h1 class="text-blue-100 text-center text-lg font-semibold">
                  Improved Credit Score and Savings
                </h1>
              </div>
              <div>
                <p class="text-white py-1 px-4 text-center text-sm leading-tight">
                  To help improve employees’ financial well-being.
                </p>
              </div>
            </div>
          </div>
        </div>
        <a
          href="https://vivafinance.typeform.com/to/iQgjRv"
          rel="noopener"
          target="_blank"
          class="text-sm text-center w-auto border-b border-blue-200 pb-2 px-2 font-semibold mt-4 hover:text-white text-blue-200"
        >
          Contact Us to Learn More</a
        >
      </div>
    </section>
    <section class="container py-6">
      <div class="md:block hidden flex flex-col items-center justify-center">
        <h2 class="text-xl font-semibold mb-1">Why Choose VIVA</h2>
        <div class="h-1 w-6 rounded viva-blue mb-4"></div>
      </div>
      <div class="flex items-center justify-center">
        <div class="md:hidden flex flex-col px-3">
          <h2 class="text-lg font-semibold mb-1">Why Choose VIVA</h2>
          <div class="h-1 w-6 rounded viva-blue mb-4"></div>
        </div>
      </div>

      <div class="order-md-1 px-4 md:px-0 md:py-5 container">
        <div class="flex flex-col lg:flex-row lg:items-start items-center justify-center">
          <div class="flex flex-col md:px-6 w-full md:w-2/3 lg:w-1/3 lg:mr-2 mb-4">
            <img
              src="img/sketches/hardWork.svg"
              alt="img"
              class="h-56 w-full card-shadow dashboard-card p-5"
            />
            <div class="flex flex-col justify-start mt-4">
              <h3 class="text-center">Less Distracted, More Productive Workers</h3>
            </div>
          </div>
          <div class="flex flex-col md:px-6 w-full md:w-2/3 lg:w-1/3 mb-4">
            <img
              src="img/sketches/employeeBen.svg"
              alt="img"
              class="h-56 w-full card-shadow dashboard-card p-5"
            />
            <div class="flex flex-col justify-start mt-4">
              <h3 class="text-center">Improved Benefits Offerings to Employees</h3>
            </div>
          </div>
          <div class="flex flex-col md:px-6 w-full md:w-2/3 lg:w-1/3 lg:ml-2 mb-4">
            <img
              src="img/sketches/noCost.svg"
              alt="img"
              class="h-56 w-full card-shadow dashboard-card p-5"
            />
            <div class="flex flex-col justify-start mt-4">
              <h3 class="text-center">Zero Cost to Your Company</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import AnimatedNumber from 'animated-number-vue'
// import { Tooltip } from 'element-ui'
import Tooltip from 'element-ui/lib/tooltip'

export default {
  name: 'employers-page',
  components: {
    [Tooltip.name]: Tooltip,
    AnimatedNumber
  },
  data() {
    return {
      value: 59,
      value2: 78,
      value3: 47
    }
  },
  methods: {
    formatToPrice(value) {
      return `${value.toFixed()}%`
    },
    formatToPrice2(value2) {
      return `${value2.toFixed()}%`
    },
    formatToPrice3(value3) {
      return `${value3.toFixed()}%`
    }
  },
  mounted() {
    this.$refs.line.animate(0.59)
    this.$refs.line2.animate(0.78)
    this.$refs.line3.animate(0.47)
  }
}
</script>
